import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { useHistory, useParams } from 'react-router-dom';
import { isExternalUrl, redirect as redirectUrl, isDocumentsAndMediaUrl } from 'js/utils/url.util';

import { formatPath, getStateWithPrevPath } from './helpers';

export const useNavigate = ({ replace = false, redirect = false }: {
    replace?: boolean;
    redirect?: boolean;
} = {}) => {
    const history = useHistory();
    const { pathLang = '' } = useParams<{ pathLang: string }>();
    const { useTrailingSlash } = useAppSelector(prop('seo'));

    return useCallback((path: string, state?: unknown, {
        removeParams = [],
        preserveSearchParams = true,
        preserveHash = false
    }: {
        removeParams?: string[];
        preserveSearchParams?: boolean;
        preserveHash?: boolean;
    } = {}) => {
        if (isExternalUrl(path) || isDocumentsAndMediaUrl(path) || redirect) {
            redirectUrl(path);

            return;
        }

        const { search, hash, pathname } = window.location;
        const location = formatPath(
            path,
            pathLang,
            preserveSearchParams ? search : {},
            preserveHash ? hash : '',
            removeParams,
            useTrailingSlash
        );
        const currentLocation = formatPath(pathname, pathLang, search, hash, [], useTrailingSlash);

        if (replace) {
            history.replace(location, state);
        } else if (location !== currentLocation) {
            history.push(location, getStateWithPrevPath(path, state));
        }
    }, [
        pathLang,
        replace,
        history,
        redirect,
        useTrailingSlash
    ]);
};

